import {ICompanyLogo} from '@core/api/data-access';
import {StoredFile} from '@global-data';
import {BE} from '@utils';

import BESchema = BE.BESchema;
import BEProp = BE.BEProp;
@BESchema()
export class CompanyLogo implements ICompanyLogo {
	@BEProp() type: string;
	@BEProp() data: string;

	storedCompanyLogoFile: StoredFile;

	constructor(init?: Partial<ICompanyLogo>) {
		Object.assign(this, init);
		this.storedCompanyLogoFile = new StoredFile(this.data, this.type);
	}
}
